import View               from '@widesk-ui/components/View';
import useTheme           from '@widesk-ui/hooks/useTheme';
import LayoutHeaderLogout from '@widesk-ui/components/LayoutHeaderLogout';
import ViewPrimary        from '@widesk-ui/components/ViewPrimary';
import { useNavigate }    from 'react-router-dom';
import useThemeMode       from '@widesk-ui/hooks/useThemeMode';
import appStore           from '@/stores/appStore';
import ButtonActions      from '@widesk-ui/components/ButtonActions';
import Img                from '@widesk-ui/components/Img';
import SiderSelectProject from './SiderSelectProject';

export default function LayoutHeader() {
	const { marginLG } = useTheme();
	const navigate = useNavigate();

	return (
		<View row>
			<SiderSelectProject />

			<ViewPrimary
				size={16}
				bold
				paddingH={marginLG}
				separatorL
				separatorProps={{ bg: 'white' }}
				onClick={() => {
					navigate('/');
					appStore.resetWebsiteEntertainmentId();
				}}
				row
				gap="xs"
				minW={250}
			>
				<Img src={window.APP_CONFIG.services.find(s => s.id === 'website')?.icon || ''} width={20} preview={false} /> Gestion du site public
			</ViewPrimary>

			<View row style={{ marginLeft: 'auto' }}>
				<UserHeaderSettings />

				<LayoutHeaderLogout />
			</View>
		</View>
	);
}

const UserHeaderSettings = () => {
	const { mode, setMode } = useThemeMode();
	const { colorPrimary } = useTheme();
	const isDark = mode === 'dark';

	return (
		<View bg={colorPrimary} color="white" center minWidth={150}>
			<ButtonActions
				actions={[
					{
						label: 'Afficher le thème ' + (isDark ? 'clair' : 'sombre'),
						onClick: () => setMode(isDark ? 'light' : 'dark'),
					},
				]}
				icon={appStore.user?.renderName({ imageSize: 'middle' })}
				type="text"
				block
				style={{ color: 'white', height: '100%', borderRadius: 0 }}
			/>
		</View>
	);
};
